import TUCardStatsTable from './TUCardStatsTable';

export default TUCardStatsTable;
